document.addEventListener('DOMContentLoaded',()=>{const els=document.querySelectorAll('.tl-reveal');if(!('IntersectionObserver'in window)){els.forEach(e=>e.classList.add('tl-visible'));return}const io=new IntersectionObserver((entries)=>{entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('tl-visible');io.unobserve(e.target)}})},{threshold:.12,rootMargin:'0px 0px -35px 0px'});els.forEach(e=>io.observe(e));});
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('a[href^="#"]').forEach(a=>{
    a.addEventListener('click',e=>{
      const id=a.getAttribute('href');
      if(!id||id==='#'){e.preventDefault();window.scrollTo({top:0,behavior:'smooth'});return;}
      const target=document.querySelector(id);
      if(target){e.preventDefault();target.scrollIntoView({behavior:'smooth',block:'start'});}
      else{e.preventDefault();window.location.href='/' + id;}
    });
  });
});